<template>
  <div class="cont">
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>安全管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="box">
      <div class="box-r">
        <div style="height: 6vh;padding: 0 8px;" class="between-center">
          <div class="items-center">
            <el-input v-model="searchParams.fileName" placeholder="请输入文件名称查询" size="small" clearable />
            <el-button style="margin-left: 0.52vw;" size="mini" type="primary" plain @click="handleSizeChange()">
              查询
            </el-button>
          </div>
          <el-button size="mini" type="primary" plain @click="addTeam()">上传</el-button>
        </div>
        <div class="box-r-b">
          <div style="padding:0 8px">
            <el-table height="73vh" :data="tableData" border
              :header-cell-style="{ background: '#F5F7F9', color: '#909399', fontFamily: 'MicrosoftYaHei', fontSize: '16px' }">
              <el-table-column label="序号" prop="index" width="70" />
              <el-table-column prop="fileName" label="名称">
                <template slot-scope="scope">
                  <div class="hidden justify-center" @click="showFile(scope.row)">
                    <img
                      v-if="scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'doc' || scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'docx'"
                      src="../../../assets/image/fileImgS/Word.png" alt="">
                    <img
                      v-else-if="scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'xlsx' || scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'xls'"
                      src="../../../assets/image/fileImgS/excel.png" alt="">
                    <img
                      v-else-if="scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'PDF' || scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'pdf'"
                      src="../../../assets/image/fileImgS/PDF.png" alt="">
                    <img
                      v-else-if="scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'png' || scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'jpg' || scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'JPG' || scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'jpeg' || scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'JPEG' || scope.row.fileName.split('.')[scope.row.fileName.split('.').length - 1] == 'jfif'"
                      src="../../../assets/image/fileImgS/图片.png" alt="">
                    <img v-else src="../../../assets/image/fileImgS/c652d4178d8bd28c62bc4dc8679bcc8.png" alt="">
                    <span style="font-size:14px;
                    overflow: hidden;text-overflow:ellipsis;white-space: nowrap;
                    margin-left:5px;
                    cursor: pointer;
                    ">{{ scope.row.fileName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="上传时间" prop="createDate" />
              <el-table-column label="备注" prop="remark" />
              <el-table-column label="操作" width="280">
                <template slot-scope="scope">
                  <div class="justify-evenly">
                    <el-button size="mini" type="primary" plain @click="download(scope.row)">下载</el-button>
                    <el-button style="margin: 0;" size="mini" type="primary" plain @click="handleEdit(scope.row)">
                      编辑
                    </el-button>
                    <el-button style="margin: 0;" size="mini" type="danger" @click="handleDelete(scope.row)">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
            :current-page.sync="searchParams.pageNum" :page-sizes="[20, 50, 100, 200]"
            :page-size.sync="searchParams.pageSize" @current-change="findProjectFileList()"
            @size-change="handleSizeChange()" />
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog :title="diaTitle" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
      width="30%">
      <el-form :model="addForm" ref="addForm" label-width="150px" label-position="right" class="teamPage">
        <el-form-item label="上传文件:" prop="managerTel">
          <el-upload class="upload-demo" v-bind:action="uploadUrl" :headers="uploadHead"
            :data="{ type: 245, projectId, }" :show-file-list="false" :on-success="fileSuccess">
            <i v-if="!addForm.fileUrl" class="el-icon-plus avatar-uploader-icon"></i>
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <img v-if="addForm.fileUrl" src="../../../assets/image/fileicon.png" style="width:5vh;height:5vh;" />
              <span v-if="addForm.fileUrl">{{ addForm.fileName }}</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="addForm.remark" type="textarea" placeholder="请输入内容" autocomplete="off" style="width:220px"
            :rows="16"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'

export default {
  data() {
    const projectId = util.session.get('groupId');
    return {
      projectId,
      diaTitle: '',
      dataTree: [],
      defaultProps: { children: 'children', label: 'name' },
      addForm: { fileId: '', fileName: '', fileSize: '', fileUrl: '', remark: '', },
      searchParams: { fileName: '', pageNum: 1, pageSize: 20, projectId, },
      tableData: [],
      total: 0,
      uploadUrl: 'https://sites.tongsheng01.com/upload/uploadFile',
      uploadHead: { accessToken: this.$store.state.token, },
      addFormVisible: false,
      fileType: '',
      name: ''
    }
  },

  watch: {
    $route: {
      handler() {
        this.fileType = this.$route.query.fileType || '';
        this.name = this.$route.query.name || '';
        this.findProjectFileList();
      },
      deep: true,
      immediate: true,
    }
  },

  methods: {
    download(row) {
      const token = util.session.get('token')
      window.open(`${myHttp.downloadFileDj}?accessToken=${token}&fileUrl=${base.httpCtx + row.fileUrl}&fileName=${row.fileName}`);
    },

    showFile(row) {
      window.open(`${base.fileView}/onlinePreview?url=${encodeURIComponent(base.httpCtx + row.fileUrl)}`, '_blank');
    },

    handleEdit(row) {
      const { fileId, fileName, fileSize, fileUrl, remark, } = row;
      this.addForm = { fileId, fileName, fileSize, fileUrl, remark, };
      this.diaTitle = '修改'
      this.addFormVisible = true
    },

    handleDelete(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteProjectFile({ fileId: row.fileId, }).then(res => {
          if (res.data.code == '200') {
            this.$message.success('删除成功');
            this.handleSizeChange();
          } else {
            this.$message.error(res.data.msg);
          }
        })
      });
    },

    fileSuccess(res, file) {
      if (res.code == 200) {
        this.addForm.fileName = file.name;
        this.addForm.fileUrl = res.data.fileUrl;
        this.addForm.fileSize = res.data.fileSize;
      } else {
        this.$message.error(res.msg);
      }
    },

    sumbitAddRow() {
      if (!this.addForm.fileUrl) {
        this.$message.error('请上传文件！');
        return;
      }
      if (!this.addForm.fileId) {
        myHttp.addProjectFile({ ...this.addForm, fileType: this.fileType, projectId: this.projectId, }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('添加成功')
            this.addFormVisible = false
            this.handleSizeChange()
          } else {
            this.$message.error(res.data.msg)
          }
        });
      } else {
        myHttp.editProjectFile({ ...this.addForm, fileType: this.fileType, projectId: this.projectId, }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('修改成功')
            this.addFormVisible = false
            this.findProjectFileList()
          } else {
            this.$message.error(res.data.msg)
          }
        });
      }
    },

    addTeam() {
      this.addForm = {
        fileId: '',
        fileName: '',
        fileSize: '',
        fileType: '',
        fileUrl: '',
        remark: '',
      }
      this.diaTitle = '添加'
      this.addFormVisible = true
    },

    handleSizeChange() {
      this.searchParams.pageNum = 1;
      this.findProjectFileList();
    },

    findProjectFileList() {
      myHttp.findProjectFileList({ ...this.searchParams, fileType: this.fileType, }).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
          if (this.tableData.length) {
            const { pageNum, pageSize, } = this.searchParams;
            this.tableData.forEach(ele => {
              ele.visible = false;
              ele.index = (pageNum - 1) * pageSize + (i + 1);
              ele.fileFormat = ele.fileName ? this.getImg(ele.fileName) : '0';
            });
          } else {
            this.dataText = '暂无数据';
          }
        }
      })
    },

    getImg(url) {
      // 1:word   2:excel    3:pdf     4:img   5:undefined
      var result = '';
      var list = url.split('.')
      var str = list[list.length - 1]
      if (base.docType.indexOf(str) >= 0) {
        result = '1'
      } else if (base.imgType.indexOf(str) >= 0) {
        result = '4'
      } else if (base.excelType.indexOf(str) >= 0) {
        result = '2'
      } else if (base.pdfType.indexOf(str) >= 0) {
        result = '3'
      } else if (base.cadType.indexOf(str) >= 0) {
        result = '5'
      } else {
        result = '6'
      }
      return result
    },
  }
}
</script>

<style scoped>
.cont {
  width: 100%;
  height: 100%;
  background-color: rgb(236, 240, 245);
  padding: 0 24px 10px 8px;
}

.title {
  height: 4vh;
  display: flex;
  align-items: center;
}

.box {
  display: flex;
  height: 85vh;
}

.box-r {
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
  flex: 1;
  overflow: hidden;
}

.box-r-b {
  height: 72vh;
}

::v-deep .cell>span {
  font-size: 14px !important;
}

::v-deep .cell {
  font-size: 14px !important;
}

::v-deep .el-dialog__header {
  text-align: start;

  background: #F1F1F1;
}

::v-deep .el-dialog__header>.el-dialog__title {
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}

::v-deep .el-dialog {
  border-radius: 6px;
  overflow: hidden;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>